module.exports = __webpack_public_path__ + "media/Pandora-Garden-sm.c5c39b76.mp4";